import {
  CREATE_IN_CAMP_TRAINING,
  CREATE_IN_CAMP_TRAINING_FAILURE,
  CREATE_IN_CAMP_TRAINING_SUCCESS,
  CREATE_IN_CAMP_TRAINING_RESET,

  UPDATE_IN_CAMP_TRAINING,
  UPDATE_IN_CAMP_TRAINING_SUCCESS,
  UPDATE_IN_CAMP_TRAINING_FAILURE,
  UPDATE_IN_CAMP_TRAINING_RESET,
} from "../ActionTypes";

const INIT_STATE = {
  creatingInCampTraining: false,
  trainingCreated: false,
  createTrainingRequestMade: false,

  updatingInCampTraining: false,
  trainingUpdated: false,
  updateTrainingRequestMade: false,
}

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case CREATE_IN_CAMP_TRAINING: return {
      ...state,
      creatingInCampTraining: true,
    }

    case CREATE_IN_CAMP_TRAINING_SUCCESS: return {
      ...state,
      creatingInCampTraining: false,
      trainingCreated: true,
      createTrainingRequestMade: true,
    }

    case CREATE_IN_CAMP_TRAINING_FAILURE: return {
      ...state,
      creatingInCampTraining: false,
      trainingCreated: false,
      createTrainingRequestMade: true,
    }

    case CREATE_IN_CAMP_TRAINING_RESET: return {
      ...state,
      creatingInCampTraining: false,
      trainingCreated: false,
      createTrainingRequestMade: false,
    }
    
    
    case UPDATE_IN_CAMP_TRAINING: return {
      ...state,
      updatingInCampTraining: true,
    }

    case UPDATE_IN_CAMP_TRAINING_SUCCESS: return {
      ...state,
      updatingInCampTraining: false,
      trainingUpdated: true,
      updateTrainingRequestMade: true,
    }

    case UPDATE_IN_CAMP_TRAINING_FAILURE: return {
      ...state,
      updatingInCampTraining: false,
      trainingUpdated: false,
      updateTrainingRequestMade: true,
    }

    case UPDATE_IN_CAMP_TRAINING_RESET: return {
      ...state,
      updatingInCampTraining: false,
      trainingUpdated: false,
      updateTrainingRequestMade: false,
    }

    default: return state;
  }
}

export default reducers;